// Import model
import { UpdateSurfaceRequest } from '../models/UpdateSurfaceRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdatePointRequest } from '../models/UpdatePointRequest';

// Import dependency serializers (for complex types)
import { UpdatePointRequestSerializer } from './UpdatePointRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSurfaceRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSurfaceRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSurfaceRequest instance
   */
  static deserialize(json: string): UpdateSurfaceRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSurfaceRequest instance
   */
  static fromObject(obj: any): UpdateSurfaceRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSurfaceRequest');
    }


    const instance: UpdateSurfaceRequest = {
      area: obj['area'] as number | undefined,
      name: obj['name'] as string | undefined,
      perimeter: obj['perimeter'] as number | undefined,
      shape: obj['shape'] ? (obj['shape'] as any[]).map((item: any) =>
        UpdatePointRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSurfaceRequest instances
   */
  static deserializeArray(json: string): UpdateSurfaceRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSurfaceRequest instance to a JSON string
   */
  static serialize(instance: UpdateSurfaceRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSurfaceRequest instance to a plain object
   */
  static toObject(instance: UpdateSurfaceRequest): any {
    return {
      'area': instance.area,
      'name': instance.name,
      'perimeter': instance.perimeter,
      'shape': instance.shape?.map((item: any) =>
        UpdatePointRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of UpdateSurfaceRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSurfaceRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
